import { isValidURL } from "../configs/commons";
import { HEROKU_AUTHORIZATION, HEROKU_CRUZEIRO_CPF_CHECK, HEROKU_CRUZEIRO_SOCIO_SSO_EXTERNAL, HEROKU_CRUZEIRO_SOCIO_SSO_REGISTER, HEROKU_CRUZEIRO_TICKET_CHECK, HEROKU_CRUZEIRO_FENG_BASIC_SSO_LOGIN } from "./URLconsts";

export const baladaAppStagingDomain = 'https://socio.cruzeiro.com.br';

const CruzeiroApi = {
  socioSSO: async function (params) {
    const { user, plan, dataHelper, redirect_uri } = params;
    var result = {
      success: false,
      code: 0,
      data: [],
    };

    const postData = {
      userId: user.FirebaseId__c,
      plan,
      redirect_uri,
    };

    console.log("postData", postData);

    const postUrl = await dataHelper.getHerokuUrlV2(
      HEROKU_CRUZEIRO_SOCIO_SSO_EXTERNAL
    );

    await dataHelper.api.post(postUrl, postData)
      .then((response) => response.json())
      .then((data) => {
        if (data?.error?.code) {
          result = {
            success: false,
            code: data.error.code,
            message: data.error.message,
          };
        } else if (data?.res) {
          result.success = true;
          result.url = data.res;
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return result;
  },
  socioRegister: async function (userData, dataHelper) {
    var result = {
      success: false,
      code: 0,
      data: [],
    };

    const postData = { userId: userData.FirebaseId__c, userFirebaseId: userData.FirebaseId__c };

    const postUrl = await dataHelper.getHerokuUrlV2(
      HEROKU_CRUZEIRO_SOCIO_SSO_REGISTER
    );

    await dataHelper.api.post(postUrl, postData)
      .then((response) => response.json())
      .then((data) => {
        if (data?.error?.code) {
          result = {
            success: false,
            code: data.error.code,
            message: data.error.message,
          };
        } else if (data?.res) {
          result.success = true;
          result.fengId = data.res.user.idpessoa;
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return result;
  },
  CPFCheck: async function (userData, dataHelper) {
    let data = {
      userId: userData.FirebaseId__c,
      userFirebaseId: userData.FirebaseId__c
    };

    var cpfCheckUrl = await dataHelper.getHerokuUrlV2(HEROKU_CRUZEIRO_CPF_CHECK);

    try {  
      let response = await dataHelper.api.get(cpfCheckUrl + "?" + new URLSearchParams(data))

      if (response.ok) {
        let result = await response.json();
        return result;
      }
    } catch (e) {
      console.log("e", e);
    }
  },
  socioSSOFeng: async function (userData, dataHelper) {
    var result = {
      success: false,
      code: 0,
      data: [],
    };

    const postData = { cpf: '12520749644', idpessoa: userData.IdFeng__c || userData.FengId__c, userFirebaseId: userData.FirebaseId__c };

    const postUrl = await dataHelper.getHerokuUrlV2(HEROKU_CRUZEIRO_FENG_BASIC_SSO_LOGIN);

    await dataHelper.api.post(postUrl, postData)
      .then((response) => response.json())
      .then((data) => {
        if (data?.error?.code) {
          result = {
            success: false,
            code: data.error.code,
            message: data.error.message,
          };
        } else if (data?.res) {
          result.success = true;
          result.url = data.res;
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return result;
  },

  // SSO BaladApp
  ticketsSSO: async function (ticketId, email, dataHelper) {
    const newWindow = window.open('about:blank', '_blank');
    
    try {
      if (ticketId && isValidURL(ticketId)) {
        return newWindow.location.href = ticketId;
      }

      if (!email) {
        return newWindow.location.href = "https://acesso.cruzeiro.com.br/";
      }
      
      const payload = {
        email,
        redirectTo: ticketId ? `/jogos/${ticketId}` : '/jogos',
      };

      const apiUrl = await dataHelper.getHerokuUrlV2('/genBaladaAppUserToken');

      const response = await dataHelper.api.post(apiUrl, payload);

      const responseData = await response.json();
      if (responseData.token) {
        return newWindow.location.href = `${baladaAppStagingDomain}/api/partner/v1/auth?jwt=${responseData.token}`;
      }
    } catch (error) {
    }
    
    return newWindow.location.href = "https://acesso.cruzeiro.com.br/";
  },

  goToSocio: async function (email, redirectTo, dataHelper) {
    const newWindow = window.open('about:blank', '_blank');

    console.log(``, email, redirectTo)
 
    const payload = {
      email,
      redirectTo,
    };

    try {
      const response = await dataHelper.api.post("/restHelper/genBaladaAppUserToken", payload);

      const responseData = await response.json();

      if (responseData.token) {


        return newWindow.location.href = `${baladaAppStagingDomain}/api/partner/v1/auth?jwt=${responseData.token}`;
      }
    } catch (e) {
      console.log('buy ticket url error', e)
    }

    return newWindow.location.href = baladaAppStagingDomain + redirectTo;
  }
}

export default CruzeiroApi;
